export const guestComps = {
  detail: {
    nav: {
      overview: "Informações",
      bookings: "Reservas",
      checkins: "Check-ins",
      invoicing: "Faturamento",
    },
    personalInfo: "Informações pessoais",
    contactInfo: "Informações de contato",
    residenceInfo: "Informações de residência",
    fields: {
      firstName: "Nome",
      lastName: "Sobrenome",
      document: "Documento",
      nationality: "Nacionalidade",
      country: "País",
      birthDate: "Data de nascimento",
      email: "E-mail",
      whatsapp: "WhatsApp",
      countryResidence: "País de residência",
      cityResidence: "Cidade de residência",
      relationship: "Parentesco",
    },
    cols: {
      code: "Código",
      accommodation: "Acomodação",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Status",
      total: "Total",
      guest: "Hóspede",
      booking: "Reserva",
      entryDate: "Data de entrada",
      date: "Data",
    },
    confirmed: "Confirmada",
    fiscalProfile: "Perfil fiscal registrado",
    legalName: "Razão social",
    taxId: "Identificação fiscal",
    type: "Tipo",
    company: "Empresa",
    individual: "Pessoa física",
    invoicesIssued: "Faturas emitidas",
    empty: {
      bookings: "Nenhuma reserva registrada para este hóspede.",
      checkins: "Nenhum check-in registrado para este hóspede.",
      invoices: "Nenhuma fatura emitida para este hóspede.",
    },
    noPdf: "Sem PDF",
    status: {
      sent: "Emitida",
      processing: "Processando",
      error: "Erro",
      pending: "Pendente",
    },
    close: "Fechar",
  },
  form: {
    editTitle: "Editar cliente",
    newTitle: "Novo cliente",
    subtitle: "Dados de contato e faturamento para próximas reservas e faturas.",
    subtitleEmbedded: "Complete o perfil e você voltará para a fatura sem perder as cobranças.",
    backToInvoice: "Voltar para a fatura",
    close: "Fechar",
    customerTypeAria: "Tipo de cliente",
    typeIndividual: "Pessoa física",
    typeIndividualHelp: "Pessoa natural",
    typeCompany: "Empresa",
    typeCompanyHelp: "Pessoa jurídica",
    identity: "Identidade",
    identityDesc: "Dados que identificam o destinatário da fatura.",
    name: "Nome",
    namePlaceholder: "João",
    lastName: "Sobrenome",
    lastNamePlaceholder: "Silva",
    legalName: "Razão social",
    legalNamePlaceholder: "Empresa Exemplo Ltda.",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Documento fiscal",
    docPlaceholderIndividual: "DNI, NIE ou passaporte",
    docType: "Tipo de documento",
    select: "Selecionar",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Passaporte",
    docOther: "Outro documento",
    contact: "Contato",
    contactDesc: "Canais para enviar a fatura ou contatar o cliente.",
    email: "E-mail",
    emailPlaceholder: "customer@email.com",
    phone: "Telefone",
    fiscalAddress: "Endereço fiscal",
    fiscalAddressDesc: "Usado como endereço do destinatário em uma fatura completa.",
    country: "País",
    address: "Endereço",
    addressPlaceholder: "Rua, número e andar",
    city: "Cidade",
    cityPlaceholder: "Madri",
    state: "Província / Estado",
    postalCode: "Código postal",
    postalPlaceholder: "28001",
    requiredNote: "* Campos obrigatórios para o perfil fiscal",
    backToInvoiceShort: "Voltar para a fatura",
    cancel: "Cancelar",
    saving: "Salvando…",
    saveChanges: "Salvar alterações",
    createClient: "Criar cliente",
    err: {
      name: "Informe o nome.",
      lastName: "Informe o sobrenome.",
      legalName: "Informe a razão social.",
      taxId: "A identificação fiscal é obrigatória para empresas.",
      country: "Selecione o país.",
      address: "Informe o endereço fiscal.",
      city: "Informe a cidade.",
      postalCode: "Informe o código postal.",
      email: "Informe um e-mail válido.",
      saveFailed: "Não foi possível salvar o cliente.",
    },
  },
  list: {
    title: "Clientes de faturamento",
    subtitle: "Perfis fiscais reutilizáveis para emitir e revisar faturas",
    searchLabel: "Buscar clientes",
    searchPlaceholder: "Nome, e-mail, telefone ou documento…",
    clearSearch: "Limpar busca",
    exporting: "Exportando...",
    exportClients: "Exportar clientes",
    newClient: "Novo cliente",
    cols: {
      fiscalClient: "Cliente fiscal",
      contact: "Contato",
      fiscalDocument: "Documento fiscal",
      country: "País",
      linkedBookings: "Reservas vinculadas",
      invoices: "Faturas",
      actions: "Ações",
    },
    company: "Empresa",
    individual: "Pessoa física",
    noEmail: "Nenhum e-mail atribuído",
    noPhone: "Nenhum telefone atribuído",
    viewInvoicesTitle: "Ver {count} fatura deste hóspede | Ver {count} faturas deste hóspede",
    invoicesCount: "{count} fatura | {count} faturas",
    noInvoices: "Sem faturas",
    editClient: "Editar cliente",
    edit: "Editar",
    viewDetail: "Ver detalhes",
    view: "Ver",
    emptySearchTitle: "Nenhum perfil fiscal encontrado",
    emptySearchSub: "Nenhum cliente de faturamento corresponde a “{term}”.",
    emptyTitle: "Ainda não há clientes de faturamento",
    emptySub: "Crie um perfil fiscal ao emitir uma fatura, ou salve um agora para reutilizá-lo depois.",
    createFirst: "Criar primeiro cliente",
    selectedClient: "Cliente selecionado",
  },
  internalName: {
    addBtn: "nome interno",
    title: "Nome interno",
    hint: "Só você pode vê-lo. Ele aparece antes do nome público nas suas listas e calendários.",
    removeWarn: "Ele será removido das suas listas. As mensagens de código de acesso e o Agente de IA não indicarão mais a qual acomodação se refere.",
    edit: "Editar",
    cancel: "Cancelar",
    removing: "Removendo…",
    confirmRemove: "Sim, remover",
    remove: "Remover",
    editTitle: "Editar nome interno",
    addTitle: "Adicionar nome interno",
    eyebrow: "Nome interno da acomodação",
    modalHint: "Um nome privado para você reconhecer a acomodação rapidamente (por exemplo «Sótão Roser» ou «Segundo»). Seus hóspedes nunca o veem.",
    placeholder: "Sótão Roser",
    previewLabel: "Você verá assim",
    saving: "Salvando…",
    save: "Salvar",
    saveFailed: "Não foi possível salvar o nome interno.",
  },
};
